'use client'

import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { ListItemRenderer } from '@dustin-web/product-components/src/product-list'
import { Button } from '@dustin-web/microsite-components/src/button'
import { ProductCardGallerySkeleton } from '@dustin-web/microsite-components/src/skeleton'
import { withGods } from './hocs/products-with-data-hoc'
import { WrappedComponentProps } from './types/types'

export const ProductsList = ({ button, products, isLoading }: WrappedComponentProps) => {
  const btnText = button && button[0]?.properties?.link?.text
  const btnUrl = button && button[0]?.properties?.link?.url
  const isBtnTextEmpty = btnText === btnUrl
  const { translate } = useTranslations()

  if (isLoading) {
    return (
      <div className="row d-flex">
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
      </div>
    )
  } else if (products && products?.length) {
    return (
      <>
        <div className="row">
          {products?.map(
            (r: any, key: number) =>
              r.searchResultProduct && (
                <ListItemRenderer
                  key={r.ticket + key}
                  product={r.searchResultProduct}
                  ticket={r.ticket}
                  listType={'gallery'}
                  digitalDataOrigin={'topSellersContentBlock'}
                  digitalIndex={key}
                />
              )
          )}
        </div>
        {!!btnText && !!btnUrl && (
          <div className="d-flex justify-content-end">
            <Button
              primary
              icon="arrow-right"
              iconSize="16"
              text={(isBtnTextEmpty && translate('ShowAll')) || btnText}
              href={btnUrl}
              link={true}
              className="align-self-end"
            />
          </div>
        )}
      </>
    )
  } else {
    return <p>No products avalible</p>
  }
}

const ProductsListWithGoods = withGods(ProductsList)

export const ProductsListBlock = ProductsListWithGoods
